export const getCountryValue = (language) => {
  switch (language) {
    case 'fr':
      return 'FR'
    case 'es':
      return 'ES'
    case 'it':
      return 'IT'
    case 'de':
      return 'DE'
    case 'en':
      return 'US'
    case 'fr-BE':
      return 'BE'
    
    default:
      return undefined;
  }
};

export const shouldForceCartesBancairesResave = stripePaymentMethodDetails => {
  const availableNetworks = stripePaymentMethodDetails?.networks?.available || [];
  const preferredNetwork = stripePaymentMethodDetails?.networks?.preferred;
  const displayBrand = stripePaymentMethodDetails?.displayBrand;
  const cardNetwork = preferredNetwork || displayBrand;
  const hasCartesBancairesNetwork = availableNetworks.includes('cartes_bancaires');
  const hasInternationalNetwork =
    availableNetworks.includes('mastercard') || availableNetworks.includes('visa');
  const usesInternationalNetwork = cardNetwork === 'mastercard' || cardNetwork === 'visa';

  return hasCartesBancairesNetwork && hasInternationalNetwork && usesInternationalNetwork;
};

export const isUsableStripePaymentMethod = stripePaymentMethodDetails => {
  if (!stripePaymentMethodDetails) {
    return false;
  }

  if (typeof stripePaymentMethodDetails.isUsable === 'boolean') {
    return stripePaymentMethodDetails.isUsable;
  }

  return !!stripePaymentMethodDetails.stripePaymentMethodId;
};

export const getStripeCustomerForPaymentMethodSave = stripeCustomer => {
  return stripeCustomer;
};
